<!--
 * @Author: MouXiaowei
 * @Date: 2022-07-26 14:24:02
 * @Description: 学生卡获奖名单
-->
<template>
  <div class="home-box">
      <div class="img-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/studentCardActive/bg_stu_card_price.png" alt="">
      </div>
  </div>
</template>
<script>

export default {
  components: {

  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  background: #fcf0c7;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-box {
    margin: 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 100%;
    }
}
</style>
